export const disconnectNativeAudioNodeFromNativeAudioNode = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input) => {
    const inputs = nativeDestinationAudioNode.inputs;
    if (input === undefined || output === undefined) {
        nativeSourceAudioNode.disconnect(nativeDestinationAudioNode);
    }
    else if (inputs !== undefined) {
        nativeSourceAudioNode.disconnect(inputs[input], output, 0);
    }
    else {
        nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
    }
};
//# sourceMappingURL=/build/es2018/helpers/disconnect-native-audio-node-from-native-audio-node.js.map